/**
 * Directive: dataGrid
 */
angular.module('acme.common.directive.dataGrid', [
  'ui.grid',
  'ui.grid.autoResize',
  'ui.grid.selection',
  'ui.grid.pagination',
  'ui.grid.resizeColumns',
  'ui.grid.edit',
  'ui.grid.grouping',
  'ui.grid.draggable-rows',
  'ui.grid.moveColumns',
  'ui.grid.saveState',
  'ui.grid.cellNav',
  'ui.grid.exporter',
  'acme.common.service.helpers'
])
.directive('dataGrid', [function() {

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/dataGrid/dataGrid.tpl.html',
    scope: {
      show: '=',
      isLoaded: '=',
      enableSorting: '@',
      useExternalSorting: '@',
      paginate: '@',
      useExternalPagination: '@',
      pageSize: '@',
      pageSizes: '=',
      pageNumber: '@',
      totalItems: '@',
      showFooter: '@',
      showEmpty: '@',
      enableColumnResizing: '@',
      enableRowSelection: '@',
      selectedItems: '=',
      multiselect: '@',
      enableGrouping: '@',
      enableCellEdit: '@',
      enableGridMenu: '@',
      columnReordering: '@',
      rowReordering: '@',
      async: '@',
      rowHeight: '@',
      dataset: '=',
      columns: '=',
      editAction: '=',
      removeAction: '=',
      doubleClickAction: '=',
      sortChangedAction: '=',
      paginationChangedAction: '=',
      columnReorderedAction: '=',
      rowSelectionChangedAction: '=',
      columnChangedAction: '=',
      fnActions: '=',
      rowClasses: '@',
      appScopeProvider: '=',
      datasetLength: '@',
      //Warning! use only if flat object structure
      flatEntityAccess: '@',
      exporterPdfHeader: '@',
      exporterPdfFooter: '@'
    },

    link: function($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: ['$scope', '$timeout', 'HelpersService', 'uiGridConstants', function($scope, $timeout, HelpersService, uiGridConstants) {

      $scope.dataGrid = {

        defaultOptions: {
          //default options
          //TODO: should this be NEVER?
          enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
          enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
          showGridFooter: false,
          enableColumnMenus: false,
          enableCellEdit: false,
          enableRowHeaderSelection: true,
          enableRowSelection: true,
          enableSelectionBatchEvent: false,
          enableGridMenu: false,
          exporterMenuCsv: false,
          exporterMenuPdf: false,
          multiSelect: false,
          noUnselect: true,
          enableColumnResizing: true,
          enableColumnMoving: false,
          enableSorting: true,
          enablePagination: false,
          useExternalSorting: false,
          useExternalPagination: false,
          enablePaginationControls: true,
          paginationCurrentPage: 1,
          paginationPageSizes: $scope.pageSizes || [$scope.pageSize],
          paginationPageSize: !isNaN(parseInt($scope.pageSize,10)) ? parseInt($scope.pageSize,10) : 50,
          minRowsToShow: 1,
          totalItems: 0,
          treeRowHeaderAlwaysVisible: false,
          flatEntityAccess: false,
          saveFilter: false,
          saveFocus: false,
          saveGrouping: false,
          savePinning: false,
          saveSelection: false,
          saveSort: false,
          saveTreeView: false,
          saveWidths: false,
          gridFooterTemplate: 'common/directives/dataGrid/customUiGridFooterTemplate.tpl.html',
          headerTemplate: 'common/directives/dataGrid/customUiGridHeaderTemplate.tpl.html',

          gridMenuCustomItems: [{
            title: 'Export visible data as pdf',
            order: 100,
            action: function ($event){
              $scope.gridApi.exporter.pdfExport('visible', 'visible');
            }
          }],
          exporterPdfHeader: '',
          exporterPdfFooter: '',
          exporterSuppressColumns: [ 'edit', 'view', 'order', 'cancel', 'booking', 'delete', 'remove' ],

          data: 'dataset',

          onRegisterApi: function(gridApi) {
            var isFunction = function(func) {
              return func && typeof func === 'function';
            };
            $scope.gridApi = gridApi;

            $scope.dataGrid.expandGroupedRows();

            $scope.dataGrid.updateGridHeight();

            if($scope.dataGrid.gridOptions.useExternalSorting || $scope.sortChangedAction) {
              $scope.gridApi.core.on.sortChanged( $scope, function(grid, columns, page) {
                if(typeof $scope.sortChangedAction === 'function') {
                  $scope.sortChangedAction(grid, columns, page);
                }
              });
            }else {
              $scope.gridApi.core.on.sortChanged( $scope, function(grid, columns) {
                if(columns && columns.length > 0) {
                  $scope.$emit('DataGrid::sortChange', {
                    field: columns[0].field,
                    direction: columns[0].sort.direction
                  });
                }
              });
            }

            if($scope.dataGrid.gridOptions.useExternalPagination || $scope.paginationChangedAction) {
              $scope.gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize){
                if ($scope.dataGrid.previousPageSize !== pageSize) {
                  $scope.dataGrid.updateGridHeight();
                }
                if(typeof $scope.paginationChangedAction === 'function') {
                  $scope.paginationChangedAction(newPage, pageSize);
                }
              });
            }else {
              $scope.gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                $scope.$emit('DataGrid::paginate', {
                  page: newPage,
                  pageSize: pageSize
                });
              });
            }

            //Note: There is a bug in the originalPosition and newPosition values - if a column is moved to the 0th position, it reports 0 when it should report 1. Ensure that there is a check for this.
            if($scope.dataGrid.gridOptions.enableColumnMoving) {
              if ($scope.columnReorderedAction) {
                $scope.gridApi.colMovable.on.columnPositionChanged($scope, function(changedColumn, originalPos, newPos) {
                  var gState = $scope.gridApi.saveState.save();
                  $scope.columnReorderedAction(changedColumn, originalPos, newPos, gState.columns);
                });
              } else {
                $scope.gridApi.colMovable.on.columnPositionChanged($scope, function(colDef, originalPosition, newPosition){
                  var gState = $scope.gridApi.saveState.save();
                  $scope.$emit('DataGrid::EventColumns', {
                    col: colDef,
                    originalPosition: originalPosition,
                    newPosition: newPosition,
                    columns: gState.columns
                  });
                });
              }
            }

            if($scope.dataGrid.gridOptions.enableRowSelection) {
              $scope.gridApi.selection.on.rowSelectionChanged($scope, $scope.dataGrid.rowSelected);
            }
            //works on any cell edit if enableCellEdit is true (even if gridOptions has enableCellEdit set to false
            $scope.gridApi.edit.on.afterCellEdit($scope, $scope.dataGrid.edit);

            if($scope.rowReordering === true || $scope.rowReordering === 'true') {
              $scope.gridApi.draggableRows.on.rowDropped($scope, function (info, rowElement) {
                console.log("Stopped dragging...", JSON.stringify(info));
                $scope.$emit('uiGridEventChangeOrder', {
                  from: info.fromIndex,
                  to: info.toIndex,
                  rowEntity: info.draggedRowEntity
                });
              });
            }

            if($scope.dataGrid.gridOptions.enableGridMenu) {
              if ($scope.columnChangedAction) {
                $scope.gridApi.core.on.columnVisibilityChanged( $scope, function(changedColumn) {
                  var gState = $scope.gridApi.saveState.save();
                  $scope.columnChangedAction(changedColumn, gState.columns);
                });
              } else {
                $scope.gridApi.core.on.columnVisibilityChanged($scope, function(changedColumn){
                  var gState = $scope.gridApi.saveState.save();
                  $scope.$emit('DataGrid::ColumnChanged', {
                    col: changedColumn,
                    columns: gState.columns
                  });
                });
              }
            }

            $scope.gridApi.cellNav.on.viewPortKeyDown($scope, function(event, rowCol) {
              if (event.keyCode === 13 && !rowCol.col.colDef.enableCellEdit && isFunction(rowCol.col.colDef.onCellNavClick)) {
                rowCol.col.colDef.onCellNavClick(rowCol.row, rowCol.col);
              }
            });

            if ($scope.gridApi.grid.options.appScopeProvider) {
              $scope.gridApi.grid.options.appScopeProvider.cellNavSort = function(col, event) {
                if (event.keyCode === 13 && col.enableSorting) {
                  if (col.sort.direction) {
                    col.sort.direction = (col.sort.direction === 'desc') ? 'asc' : 'desc';
                  } else {
                    col.sort.direction = 'asc';
                  }
                  $scope.gridApi.grid.sortColumn(col, col.sort.direction, false);
                  if (!$scope.gridApi.grid.options.useExternalSorting) {
                    $scope.gridApi.grid.api.core.refresh();
                  }
                }
              };
            } else {
              $scope.gridApi.grid.appScope.cellNavSort = function(col, event) {
                if (event.keyCode === 13 && col.enableSorting) {
                  if (col.sort.direction) {
                    col.sort.direction = (col.sort.direction === 'desc') ? 'asc' : 'desc';
                  } else {
                    col.sort.direction = 'asc';
                  }
                  $scope.gridApi.grid.sortColumn(col, col.sort.direction, false);
                  if (!$scope.gridApi.grid.options.useExternalSorting) {
                    $scope.gridApi.grid.api.core.refresh();
                  }
                }
              };
            }
          }
        },

        datasetLength: 0,

        gridHeight: {
          height: 0
        },

        gridOptions: {},

        init: function() {

          $scope.$on('$destroy', $scope.$watch('totalItems', function(n, o) {
            var self = $scope.dataGrid;
            if (n !== o) {
              self.gridOptions.totalItems = n;
              if ($scope.enableGrouping === true || $scope.enableGrouping === 'true') {
                $scope.dataGrid.expandGroupedRows();
              }
            }
          }, true));

          $scope.$on('$destroy', $scope.$watch('pageSize', function(newValue) {
            $scope.dataGrid.gridOptions.paginationPageSize = newValue;
            $scope.gridApi.core.refresh();
          }));

          $scope.$on('$destroy', $scope.$watch('columns', function(newValue) {
            $scope.dataGrid.gridOptions.columnDefs = newValue;
            $scope.gridApi.core.refresh();
          }));

          $scope.$on('$destroy', $scope.$watch('appScopeProvider', function(newValue) {
            if(newValue) {
              $scope.dataGrid.gridOptions.appScopeProvider = newValue;
              $scope.gridApi.grid.appScope = newValue;
            }
          }));

          $scope.$on('$destroy', $scope.$watch('datasetLength', function(n, o) {
            var self = $scope.dataGrid;
            if (n !== o) {
              self.datasetLength = n;
              self.updateGridHeight();
            }
          }, true));

          $scope.$on('DataGrid::DataChange', function(e, data) {
            if(data && data.type) {
              switch(data.type.toLowerCase()) {
                case 'column': $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                              break;
                case 'row':   $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ROW);
                              break;
                case 'edit':   $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
                  break;
              }
            }
          });

          $scope.$on('DataGrid::SetSelection', function(e, selected) {
            if(selected instanceof Array) {
              $scope.dataGrid.selectItems(selected);
            } else {
              $scope.dataGrid.clearSelectedItems();
            }
          });

          $scope.$on('DataGrid::ClearSelection', function(e) {
            $scope.dataGrid.clearSelectedItems();
          });

          $scope.$on('DataGrid::PreferencesUpdated', function(e, data) {
            $scope.dataGrid.gridOptions.columnDefs = data.columns;
            $scope.dataGrid.gridOptions.paginationPageSize = !isNaN(parseInt(data.pageSize, 10)) ? parseInt(data.pageSize, 10) : 50;
          });

          $scope.$on('DataGrid::CellNavCellClicked', this.onCellNavEvent);

          $scope.dataGrid.initGrid();
        },

        initGrid: function() {

          var rowClass = $scope.rowClasses ? 'ng-class="'+$scope.rowClasses+'"' : 'ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }"';

          this.gridOptions = angular.extend({}, this.defaultOptions);

          this.gridOptions.columnDefs = $scope.columns;

          if($scope.rowReordering === true || $scope.rowReordering === 'true') {
            this.gridOptions.rowTemplate = '<div grid="grid" class="ui-grid-draggable-row" draggable="true"><div ng-dblclick="grid.appScope.onGridDblClick(row)"' +
              'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
              'ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" ' +
              'class="ui-grid-cell"'+ rowClass + 'role="{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}" ' +
              'ui-grid-cell></div></div>';
          }else {
            this.gridOptions.rowTemplate = '<div ng-dblclick="grid.appScope.onGridDblClick(row)"' +
              'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
              'ui-grid-one-bind-id-grid="rowRenderIndex + \'-\' + col.uid + \'-cell\'" ' +
              'class="ui-grid-cell"'+ rowClass + 'role="{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}" ' +
              'ui-grid-cell></div>';
          }

          if ($scope.enableSorting === false || $scope.enableSorting === 'false') {
            this.gridOptions.enableSorting = false;
          }

          if ($scope.useExternalSorting === true || $scope.useExternalSorting === 'true') {
            this.gridOptions.useExternalSorting = true;
          }

          if ($scope.paginate === true || $scope.paginate === 'true') {
            this.gridOptions.enablePagination = true;
            this.gridOptions.enablePaginationControls = true;
          } else {
            this.gridOptions.enablePaginationControls = false;
          }

          if ($scope.useExternalPagination === true || $scope.useExternalPagination === 'true') {
            this.gridOptions.useExternalPagination = true;
          }

          if ($scope.pageNumber) {
            if (!isNaN(parseInt($scope.pageNumber, 10))) {
              this.gridOptions.paginationCurrentPage = parseInt($scope.pageNumber, 10);
            }
          }

          if ($scope.multiselect === true || $scope.multiselect === 'true') {
            this.gridOptions.multiSelect = true;
            this.gridOptions.noUnselect = false;
          }else {
            this.gridOptions.noUnselect = true;
          }

          if ($scope.enableColumnResizing === false || $scope.enableColumnResizing === 'false') {
            this.gridOptions.enableColumnResizing = false;
          }

          if ($scope.columnReordering === true || $scope.columnReordering === 'true') {
            this.gridOptions.enableColumnMoving = true;
          }

          if ($scope.enableRowSelection === false || $scope.enableRowSelection === 'false') {
            this.gridOptions.enableRowHeaderSelection = false;
            this.gridOptions.enableRowSelection = false;
          }

          if ($scope.enableCellEdit === true || $scope.enableCellEdit === 'true') {
            this.gridOptions.enableCellEdit = true;
          }

          if ($scope.enableGridMenu === true || $scope.enableGridMenu === 'true') {
            this.gridOptions.enableGridMenu = true;
          }

          if ($scope.showFooter === true || $scope.showFooter === 'true') {
            this.gridOptions.showGridFooter = true;
          }

          if ($scope.rowHeight) {
            this.gridOptions.rowHeight = parseInt($scope.rowHeight, 10);
          }

          if ($scope.appScopeProvider) {
            this.gridOptions.appScopeProvider = $scope.appScopeProvider;
          }else {
            this.gridOptions.appScopeProvider = $scope.dataGrid;
          }

          if($scope.dataset) {
            this.dataset = $scope.dataset;
          }

          if($scope.datasetLength) {
            this.datasetLength = $scope.datasetLength;
          }

          if($scope.exporterPdfHeader) {
            this.gridOptions.exporterPdfHeader = $scope.exporterPdfHeader;
          }

          if($scope.exporterPdfFooter) {
            this.gridOptions.exporterPdfFooter = $scope.exporterPdfFooter;
          }

          if($scope.flatEntityAccess === 'true' || $scope.flatEntityAccess === true) {
            this.gridOptions.flatEntityAccess = true;
          }

          // this needs to be after the rowHeight is set
          if ($scope.pageSize) {
            this.updateGridHeight();
          }

          console.log('DataGrid::initGrid', this.gridOptions);
        },

        updateGridHeight: function() {
          var numRows = this.datasetLength || 0,
            adjustment = $scope.enableGrouping ? 35 : 25,
            r = (this.gridOptions.minRowsToShow * this.gridOptions.rowHeight + this.gridOptions.headerRowHeight + this.gridOptions.gridFooterHeight + adjustment);
          if(this.gridOptions.minRowsToShow !== numRows) {
            if(this.gridOptions.enablePagination) {
              numRows = Math.min(numRows, this.gridOptions.paginationPageSize);
              console.log('DataGrid::updateGridHeight:'+numRows);
            }
            r = (numRows * this.gridOptions.rowHeight + this.gridOptions.headerRowHeight + this.gridOptions.gridFooterHeight + adjustment);
          }

          r = r + "px";

          console.log('DataGrid::updateGridHeight ==>'+r);
          this.gridHeight.height = r;

          this.previousPageSize = this.gridOptions.paginationPageSize;
        },

        expandGroupedRows: function() {
          var self = this;
          if ($scope.gridApi && $scope.dataset && $scope.dataset.length > 0) {
            console.log('DataGrid::dataset', $scope.dataset.length);
            $timeout (function() {
              $scope.gridApi.treeBase.expandAllRows();
            });
          }
        },

        hasPreviousPage: function() {
          return ($scope.gridApi && ($scope.gridApi.pagination.getPage() > 1));
        },

        hasNextPage: function() {
          return ($scope.gridApi && ($scope.gridApi.pagination.getPage() < $scope.gridApi.pagination.getTotalPages()));
        },

        hasItems: function() {
          var r = false;
          r = ($scope.dataset ? $scope.dataset.length : 0);
          return r;
        },

        remove: function() {
          var args;

          if ($scope.removeAction) {
            //this.restoreSorting = true;
            args = Array.prototype.slice.call(arguments);
            $scope.removeAction.apply($scope, args);
          }
        },

        edit: function() {
          var args;

          if ($scope.editAction) {
            args = Array.prototype.slice.call(arguments);
            $scope.editAction.apply($scope, args);
          }
        },

        selectItems: function(selected) {
          var i, ii;
          if ($scope.gridApi) {
            for (i = 0, ii = selected.length; i < ii; i++) {
              $scope.gridApi.selection.selectRow(selected[i]);
            }
          }
        },

        clearSelectedItems: function() {
          if ($scope.gridApi) {
            $scope.gridApi.selection.clearSelectedRows();
          }
        },

        rowSelected: function() {
          var args;

          if ($scope.rowSelectionChangedAction) {
            args = Array.prototype.slice.call(arguments);
            $scope.rowSelectionChangedAction.apply($scope, args);
          }
        },

        onGridDblClick: function(item) {
          if ($scope.doubleClickAction) {
            console.log('DataGrid::onGridDblClick', item);

            $scope.doubleClickAction(item);
          }
        },

        onCellNavEvent: function (evt, data) {
          var gridApi = $scope.gridApi, rowCol = data.rowCol;
          if (gridApi.grid.options.enableRowSelection && !rowCol.col.colDef.onCellNavClick && rowCol.col.field !== 'selectionRowHeaderCol') {
            if (rowCol.row.isSelected && !gridApi.grid.options.noUnselect) {
              gridApi.selection.unSelectRow(rowCol.row.entity);
            }else {
              gridApi.selection.selectRow(rowCol.row.entity);
            }
          }
        }

      };

      $scope.dataGrid.init();


    }]

  };

}]);